module.exports = __webpack_public_path__ + "static/media/its.bf843391.jpg";